import { Text } from '@thanx/uikit/text'
import { merchantTheme } from 'theme'

interface ContentHeaderProps {
  title: string
  description: string
  className?: string
}

const ContentHeader = ({
  title,
  description,
  className = 'mb-xl',
}: ContentHeaderProps) => {
  const { colors } = merchantTheme

  return (
    <div className={className}>
      <Text.Header3 className="mb-m">{title}</Text.Header3>
      <Text.BodyText3 color={colors.grey70}>{description}</Text.BodyText3>
    </div>
  )
}

export default ContentHeader
